import { COLORS } from './chartColors';
import { sortLabelsChronologically, formatMonthlyLabel } from './helpers/dateHelpers';
import { groupByPeriodAndKey } from './helpers/dataGroupingHelpers';
import { SelectedEntity, JobData, JobRecord } from './helpers/types';

const ALLOWED_TYPES = ['Internal', 'External'];

export const jobCountInternalExternalTransformer = (
  data: Record<string, JobData>,
  selectedEntities: SelectedEntity[]
) => {
  // Flatten all records and attach period label from key
  const allRecords: (JobRecord & { _periodLabel: string; _type: string | null })[] = [];
  Object.entries(data).forEach(([key, value]) => {
    let monthLabel: string;
    if (key.startsWith('Q')) {
      monthLabel = key;
    } else {
      const [entity_id, year, month] = key.split('_');
      monthLabel = month && year ? formatMonthlyLabel(parseInt(month), parseInt(year)) : key;
    }

    const isAllSelected = selectedEntities?.some((entity: SelectedEntity) => entity.name === 'All');
    const isEntitySelected = selectedEntities?.some(
      (entity: SelectedEntity) =>
        entity.id.toString() === (key.startsWith('Q') ? key.split('_')[0] : key.split('_')[0])
    );

    if (selectedEntities && !isAllSelected && !isEntitySelected) {
      return;
    }

    if (Array.isArray(value.data)) {
      value.data.forEach((record) => {
        const isInternal =
          record.internal === true || record.internal === 'true' || record.internal === '1';
        const isExternal =
          record.external === true || record.external === 'true' || record.external === '1';
        let type: string | null = null;
        if (isInternal && !isExternal) {
          type = 'Internal';
        } else if (!isInternal && isExternal) {
          type = 'External';
        } else {
          type = null;
        }
        if (!type) return;
        allRecords.push({ ...record, _periodLabel: monthLabel, _type: type });
      });
    }
  });

  // Group by period label and type
  const monthlyTypeCounts = groupByPeriodAndKey(
    allRecords,
    (record) => record._periodLabel,
    (record) => record._type || 'Unknown'
  );

  const sortedLabels = sortLabelsChronologically(Object.keys(monthlyTypeCounts));

  const datasets = ALLOWED_TYPES.map((type, index) => ({
    label: type,
    data: sortedLabels.map((label) => monthlyTypeCounts[label][type] || 0),
    backgroundColor: COLORS[index % COLORS.length],
    borderWidth: 1,
    stack: 'jobTypes'
  }));

  return {
    labels: sortedLabels,
    datasets
  };
};
